import type { infer as zInfer } from "zod";
import { object, enum as zEnum } from "zod";

export const setBigcommerceStoreCreditType = {
  name: "setBigcommerceStoreCreditType" as const,
  input: object({ storeCredit: zEnum(["gift_card", "store_credit"]) }),
  output: object({ success: object({}).optional() }),
};

export type SetBigcommerceStoreCreditTypeInput = zInfer<
  typeof setBigcommerceStoreCreditType.input
>;
export type SetBigcommerceStoreCreditTypeOutput = zInfer<
  typeof setBigcommerceStoreCreditType.output
>;
